export var Breakpoints = {
    MOBILE_S: 480,
    MOBILE: 600,
    TABLET: 768,
    TABLET_LANDSCAPE: 1024,
    DESKTOP: 1350,
};
//# sourceMappingURL=breakpoints.js.map